import type { BookingBalance } from '../api/endpoints/charges';
import { formatMoneyCents } from './format';

/** Shared by the visit's page and the counter, so a Cobro refreshes what both show. */
export const BOOKING_BALANCE_QUERY_KEY = 'booking-balance';

/** What the counter learned about a linked visit's payments. */
export type BookingPaymentsRead = { balance?: BookingBalance; failed: boolean };

/** The line the counter shows under a linked visit, or nothing when there is nothing to say. */
export function bookingPaymentsNotice(read: BookingPaymentsRead | undefined): string | undefined {
  if (!read) return undefined;
  if (read.failed) return 'No pudimos revisar los pagos de esta reserva. Revisa el total antes de cobrar.';
  const { balance } = read;
  if (balance?.packCovered) return 'Esta visita ya se pagó con su paquete. Agrega solo lo que falte cobrar.';
  if (!balance || balance.paidCents <= 0) return undefined;
  if (balance.balanceCents <= 0) return 'Esta reserva ya está pagada. Agrega solo lo que falte cobrar.';
  return `Esta reserva ya tiene un abono de ${formatMoneyCents(balance.paidCents)}. Falta el saldo: ${formatMoneyCents(balance.balanceCents)}.`;
}

/** What a package has left, said the way the counter reads it. */
export function packCreditsLine(creditsLeft: number | null): string {
  if (creditsLeft === null) return 'Sin límite de visitas';
  return creditsLeft === 1 ? 'Le queda 1' : `Le quedan ${creditsLeft}`;
}
